import Link from 'next/link';
import styled from 'styled-components';
import focus from '@/theme/focus';
import {sizePx} from '@/theme/helpers/size';
import colors from '@/theme/constants/colors';
import {StyledColorBlock as StyledOriginalColorBlock} from '@/pages/styles';
import zIndex from '@/theme/constants/zIndex';
import breakpoints from '@/theme/constants/breakpoints';
import {StyledFollowButton} from '@/molecules/Buttons/Follow/styles';
import StyledCtaButton from '@/atoms/Buttons/CTA/styles';

export const StyledColorBlock = styled(StyledOriginalColorBlock)`
  position: sticky;
  top: 0;
  z-index: ${zIndex.sticky};

  @media only screen and ${breakpoints.device.s} {
    top: ${sizePx(37)};
  }

  @media only screen and ${breakpoints.device.l} {
    top: 117px;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and ${breakpoints.device.m} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: ${sizePx(37)};
  }
`;

export const StyledShadow = styled.div`
  background: ${colors.white};
  height: ${sizePx(15)};
  box-shadow: 0 ${sizePx(3)} ${sizePx(3)} 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  margin-top: -${sizePx(24)};
  margin-bottom: ${sizePx(9)};
  top: 87px;
  z-index: ${zIndex.sticky - 5};

  @media only screen and ${breakpoints.device.s} {
    top: 161px;
  }

  @media only screen and ${breakpoints.device.m} {
    top: 118px;
  }

  @media only screen and ${breakpoints.device.l} {
    top: 161px;
  }
`;

export const StyledNavigationArtistPage = styled.ul`
  display: flex;
  flex-direction: row;
  gap: ${sizePx(1)};
  justify-content: space-evenly;

  & > li:first-of-type {
    margin-left: -${sizePx(3)};
  }

  @media only screen and ${breakpoints.device.m} {
    justify-content: flex-start;
  }
`;

export const StyledLink = styled(Link)`
  background: transparent;
  border-radius: ${sizePx(2)};
  padding: ${sizePx(6)} ${sizePx(3)};
  ${focus.brand()}
  display: block;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${colors.darkBlue50};
    }
  }

  @media only screen and ${breakpoints.device.m} {
    padding: ${sizePx(4)} ${sizePx(3)};
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${sizePx(6)};
  justify-content: flex-end;
  border-top: 1px solid ${colors.darkBlue25};
  padding: ${sizePx(6)} 0;

  > ${StyledCtaButton} {
    width: 100%;
  }

  ${StyledFollowButton} {
    display: none;
  }

  @media only screen and ${breakpoints.device.m} {
    border-top: none;

    > ${StyledCtaButton} {
      width: fit-content;
    }
  }

  @media only screen and ${breakpoints.device.l} {
    ${StyledFollowButton} {
      display: flex;
    }
  }
`;
